import { Link } from 'react-router-dom'
import {
  handleOpenInNewTab as sharedHandleOpenInNewTab,
  clearDocumentTabsTracking,
} from './tabManager'

export const handleEmail = (article) => {
  if (!article) return

  // Function to parse the article slug
  const parseSlug = (slug) => {
    if (!slug) return { country: '', lawName: '', docInfo: '' }

    const parts = slug.split('-')

    // Extract country (first part)
    const country = parts[0]?.toUpperCase() || ''

    // Find where the document type starts (after law identifier)
    let lawEndIndex = -1
    const docTypes = ['article', 'cd', 'md', 'fta', 'guide', 'pc', 'manual']

    for (let i = 1; i < parts.length; i++) {
      if (docTypes.includes(parts[i])) {
        lawEndIndex = i
        break
      }
    }

    // Extract law name (between country and document type)
    let lawName = ''
    if (lawEndIndex > 1) {
      const lawParts = parts.slice(1, lawEndIndex)
      // lawName = lawParts.join(' ').replace(/\b\w/g, (l) => l.toUpperCase()) // Capitalize first letter of each word
      lawName = lawParts.join(' ').toUpperCase() // Make all letters uppercase for consistency
    }

    // Extract document info (from document type onwards)
    let docInfo = ''
    if (lawEndIndex !== -1) {
      const docParts = parts.slice(lawEndIndex)
      const docType = docParts[0]
      const docIdentifier = docParts.slice(1).join(' ')

      // Format document type
      let formattedDocType = ''
      switch (docType) {
        case 'article':
          formattedDocType = 'Article'
          break
        case 'cd':
          formattedDocType = 'CD'
          break
        case 'md':
          formattedDocType = 'MD'
          break
        case 'fta':
          formattedDocType = 'FTA'
          break
        case 'guide':
          formattedDocType = 'Guide'
          break
        case 'pc':
          formattedDocType = 'PC'
          break
        case 'manual':
          formattedDocType = 'Manual'
          break
        default:
          formattedDocType = docType.toUpperCase()
      }

      // Format document identifier
      let formattedIdentifier = docIdentifier
      if (docType === 'article' && docIdentifier) {
        // For articles, just show the number
        formattedIdentifier = docIdentifier.replace(/^0+/, '') || docIdentifier
      } else if (['cd', 'md', 'fta'].includes(docType)) {
        // For decisions, format as "XX of YYYY"
        formattedIdentifier = docIdentifier.replace(/-/g, ' ').toUpperCase()
      } else {
        // For guides, pc, manual - format with proper casing
        formattedIdentifier = docIdentifier
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (l) => l.toUpperCase())
      }

      docInfo = `${formattedDocType}${
        formattedIdentifier ? ` ${formattedIdentifier}` : ''
      }`
    }

    return { country, lawName, docInfo }
  }

  // Get article title for body
  const articleTitle = article?.name || article?.title || 'a GCC Tax Document'

  // Parse the slug to get formatted parts
  const { country, lawName, docInfo } = parseSlug(article?.slug)

  // Create subject with parsed information
  let subjectParts = ['GCCTaxLaws.com']
  if (country) subjectParts.push(country)
  if (lawName) subjectParts.push(lawName)
  if (docInfo) subjectParts.push(docInfo)

  const subject = encodeURIComponent(subjectParts.join(' || '))

  // Create body with title
  const body = encodeURIComponent(`
Hi there,

I came across a document titled "${articleTitle}" on GCCTaxLaws.com that might be of interest to you.

You can view it here: ${window.location.href}

Best regards,
`)

  window.location.href = `mailto:?subject=${subject}&body=${body}`
}

// Use the shared tab manager
export const handleOpenInNewTab = sharedHandleOpenInNewTab

// Export the shared cleanup function
export { clearDocumentTabsTracking }
